// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../sfd-v2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SimulationPanel — 3-column layout (templates / active / results).
   Designed to live inside the dark DMN overlay (dark theme). */

.epx-dmn-sim {
  /* Accent tokens — host themes (e.g. sfd-v2 Themis) override these
     to repaint the simulator without touching internals. */
  --epx-dmn-sim-accent:       #0ea5e9;
  --epx-dmn-sim-accent-hover: #0891b2;
  --epx-dmn-sim-accent-soft:  #7dd3fc;
  --epx-dmn-sim-accent-deep:  #0e7490;
  --epx-dmn-sim-accent-rgb:   14, 165, 233;

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #0b1220;
  color: #e2e8f0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 12.5px;
  position: relative;
}

.epx-dmn-sim__close {
  position: absolute;
  top: 6px;
  right: 8px;
  z-index: 5;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: 1px solid #334155;
  background: rgba(15, 23, 42, 0.85);
  color: #94a3b8;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.12s, border-color 0.12s, background 0.12s;
}
.epx-dmn-sim__close:hover {
  color: #fca5a5;
  border-color: #ef4444;
  background: rgba(15, 23, 42, 0.95);
}

.epx-dmn-sim__root {
  flex: 1;
  display: grid;
  grid-template-columns: 240px 1fr 2fr;
  min-height: 0;
  gap: 1px;
  background: #1e293b;
}

.epx-dmn-sim__col {
  background: #0f172a;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.epx-dmn-sim__col-head {
  flex: 0 0 auto;
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #94a3b8;
  background: #111827;
  border-bottom: 1px solid #1e293b;
}

.epx-dmn-sim__muted {
  padding: 12px;
  color: #64748b;
  font-size: 12px;
}

/* ── Templates column ───────────────────────────────────────────── */

.epx-dmn-sim__templates {
  flex: 1;
  overflow-y: auto;
  padding: 6px;
}

.epx-dmn-sim__tpl-row {
  display: grid;
  grid-template-columns: 18px 1fr 30px 26px;
  gap: 6px;
  align-items: center;
  padding: 8px 10px;
  margin-bottom: 2px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.1s, box-shadow 0.1s;
}
.epx-dmn-sim__tpl-row:hover { background: rgba(148, 163, 184, 0.1); }
.epx-dmn-sim__tpl-row.is-active {
  background: rgba(var(--epx-dmn-sim-accent-rgb), 0.18);
  box-shadow: inset 3px 0 0 var(--epx-dmn-sim-accent);
}
.epx-dmn-sim__tpl-row.is-active .epx-dmn-sim__tpl-name {
  color: #f1f5f9;
  font-weight: 600;
}

.epx-dmn-sim__tpl-name {
  color: #e2e8f0;
  font-size: 12.5px;
  padding: 3px 2px;
  min-width: 0;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.epx-dmn-sim__tpl-name--editing {
  background: #0b1220;
  border: 1px solid var(--epx-dmn-sim-accent);
  border-radius: 3px;
  outline: none;
  color: #e2e8f0;
  font-size: 12.5px;
  padding: 3px 5px;
  font-family: inherit;
}

.epx-dmn-sim__tpl-run,
.epx-dmn-sim__tpl-del {
  background: transparent;
  border: 1px solid #334155;
  color: #94a3b8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  padding: 4px 6px;
  line-height: 1;
}
.epx-dmn-sim__tpl-run:hover { color: var(--epx-dmn-sim-accent-soft); border-color: var(--epx-dmn-sim-accent-soft); background: rgba(var(--epx-dmn-sim-accent-rgb), 0.08); }
.epx-dmn-sim__tpl-del:hover { color: #ef4444; border-color: #ef4444; background: rgba(239, 68, 68, 0.08); }

.epx-dmn-sim__tpl-toolbar,
.epx-dmn-sim__runbar {
  flex: 0 0 auto;
  display: flex;
  gap: 6px;
  padding: 6px 8px;
  border-top: 1px solid #1e293b;
}

.epx-dmn-sim__runbar {
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  background: #0b1220;
}

.epx-dmn-sim__live {
  font-size: 11px;
  color: #94a3b8;
  display: flex;
  align-items: center;
  gap: 6px;
  user-select: none;
  cursor: pointer;
}

.epx-dmn-sim__btn {
  background: #1e293b;
  border: 1px solid #334155;
  color: #e2e8f0;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.1s, border-color 0.1s;
}
.epx-dmn-sim__btn:hover { background: #334155; border-color: #475569; }
.epx-dmn-sim__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.epx-dmn-sim__btn--primary {
  background: linear-gradient(135deg, var(--epx-dmn-sim-accent-deep), var(--epx-dmn-sim-accent-hover));
  border-color: var(--epx-dmn-sim-accent-soft);
  color: #f0fdfa;
  font-weight: 500;
}
.epx-dmn-sim__btn--primary:hover {
  background: var(--epx-dmn-sim-accent-deep);
  border-color: var(--epx-dmn-sim-accent-soft);
  filter: brightness(0.92);
}
.epx-dmn-sim__btn--ghost {
  background: transparent;
  border-color: #334155;
  color: #94a3b8;
  font-size: 11px;
  padding: 4px 8px;
}
.epx-dmn-sim__btn--ghost:hover { color: #e2e8f0; background: rgba(148,163,184,0.08); }
.epx-dmn-sim__btn--link {
  background: transparent;
  border: none;
  color: var(--epx-dmn-sim-accent);
  padding: 2px 0;
  font-size: 11.5px;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.epx-dmn-sim__btn--link:hover { color: var(--epx-dmn-sim-accent-soft); }

/* ── Active scenario column ─────────────────────────────────────── */

.epx-dmn-sim__active-body {
  flex: 1;
  overflow-y: auto;
  padding: 10px 12px;
}

.epx-dmn-sim__input-row {
  margin-bottom: 12px;
}

.epx-dmn-sim__input-label {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 11px;
  color: #cbd5e1;
  margin-bottom: 4px;
  font-weight: 500;
}

.epx-dmn-sim__input-type {
  color: #64748b;
  font-size: 10px;
  font-family: monospace;
  background: #1e293b;
  padding: 1px 5px;
  border-radius: 3px;
}

.epx-dmn-sim__input {
  width: 100%;
  background: #0b1220;
  border: 1px solid #334155;
  color: #e2e8f0;
  padding: 5px 8px;
  font-size: 12px;
  border-radius: 3px;
  font-family: "SF Mono", Menlo, monospace;
}
.epx-dmn-sim__input:focus {
  outline: none;
  border-color: var(--epx-dmn-sim-accent);
  background: #020617;
}

/* ── Results column ─────────────────────────────────────────────── */

.epx-dmn-sim__results-strip {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 10px;
  display: flex;
  gap: 10px;
  align-items: stretch;
}

.epx-dmn-sim__focus-pill {
  flex: 0 0 auto;
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(var(--epx-dmn-sim-accent-rgb), 0.15);
  border: 1px solid rgba(var(--epx-dmn-sim-accent-rgb), 0.4);
  color: var(--epx-dmn-sim-accent-soft);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  white-space: nowrap;
}
.epx-dmn-sim__focus-pill strong { color: #e2e8f0; font-weight: 600; }

.epx-dmn-sim__focus-clear {
  background: transparent;
  border: none;
  color: var(--epx-dmn-sim-accent-soft);
  font-size: 13px;
  cursor: pointer;
  line-height: 1;
  padding: 0 2px;
}
.epx-dmn-sim__focus-clear:hover { color: #fca5a5; }

.epx-dmn-sim__result-card {
  flex: 0 0 260px;
  background: #111827;
  border: 1px solid #1e293b;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  max-height: 100%;
}

.epx-dmn-sim__result-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid #1e293b;
}

.epx-dmn-sim__result-icon {
  font-weight: 700;
  font-size: 14px;
  width: 18px;
  text-align: center;
}
.epx-dmn-sim__result-icon--ok   { color: #10b981; }
.epx-dmn-sim__result-icon--fail { color: #ef4444; }
.epx-dmn-sim__result-icon--idle { color: #64748b; }

.epx-dmn-sim__result-name {
  flex: 1;
  font-weight: 500;
  font-size: 12.5px;
  color: #e2e8f0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.epx-dmn-sim__result-expand {
  background: transparent;
  border: 1px solid #334155;
  color: #94a3b8;
  border-radius: 3px;
  padding: 2px 8px;
  font-size: 10.5px;
  cursor: pointer;
}
.epx-dmn-sim__result-expand:hover { color: #e2e8f0; border-color: #475569; }

.epx-dmn-sim__result-error {
  color: #fca5a5;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  padding: 6px 8px;
  border-radius: 3px;
  font-size: 11.5px;
  white-space: pre-wrap;
  font-family: "SF Mono", Menlo, monospace;
}

.epx-dmn-sim__dec {
  padding: 6px 8px;
  background: #0b1220;
  border-radius: 3px;
  border-left: 3px solid #10b981;
}
.epx-dmn-sim__dec--error { border-left-color: #ef4444; }

.epx-dmn-sim__dec-title {
  font-size: 11px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
}

.epx-dmn-sim__dec-value {
  margin: 0;
  font-family: "SF Mono", Menlo, monospace;
  font-size: 12px;
  color: #f1f5f9;
  white-space: pre-wrap;
  word-break: break-word;
}

.epx-dmn-sim__dec-meta {
  font-size: 10.5px;
  color: #64748b;
  margin-top: 4px;
}

.epx-dmn-sim__crumb {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.epx-dmn-sim__crumb-text {
  color: #fbbf24;
  font-size: 11.5px;
  font-weight: 500;
}

.epx-dmn-sim__crumb-msg {
  color: #fca5a5;
  font-family: "SF Mono", Menlo, monospace;
  font-size: 11px;
  white-space: pre-wrap;
  word-break: break-word;
}

.epx-dmn-sim__trace {
  margin-top: 4px;
  font-size: 10.5px;
}
.epx-dmn-sim__trace summary {
  cursor: pointer;
  color: #94a3b8;
  padding: 2px 0;
}
.epx-dmn-sim__trace pre {
  margin: 4px 0 0;
  padding: 6px 8px;
  background: #020617;
  border-radius: 3px;
  font-family: "SF Mono", Menlo, monospace;
  font-size: 10.5px;
  color: #cbd5e1;
  white-space: pre-wrap;
  word-break: break-all;
  max-height: 140px;
  overflow-y: auto;
}

/* ── Active column: subheaders + expected section ────────────────── */

.epx-dmn-sim__subhead {
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #94a3b8;
  margin: 0 0 8px;
  padding-bottom: 4px;
  border-bottom: 1px solid #1e293b;
}

.epx-dmn-sim__expected {
  margin-top: 18px;
  border-top: 1px dashed #1e293b;
  padding-top: 10px;
}

.epx-dmn-sim__expected-head {
  width: 100%;
  display: flex;
  align-items: baseline;
  gap: 6px;
  background: transparent;
  border: none;
  color: #cbd5e1;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 4px 0;
  cursor: pointer;
  text-align: left;
}
.epx-dmn-sim__expected-head:hover { color: #e2e8f0; }

.epx-dmn-sim__expected-caret {
  font-size: 10px;
  color: #64748b;
  width: 12px;
  display: inline-block;
}

.epx-dmn-sim__expected-hint {
  text-transform: none;
  letter-spacing: 0;
  font-weight: 400;
  color: #64748b;
  font-size: 10.5px;
}

.epx-dmn-sim__expected-body {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.epx-dmn-sim__expected-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.epx-dmn-sim__expected-label {
  font-size: 11.5px;
  color: #cbd5e1;
  font-weight: 500;
}

.epx-dmn-sim__expected-grid {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 8px;
  border-left: 2px solid #1e293b;
}

.epx-dmn-sim__expected-sub {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.epx-dmn-sim__expected-sublabel {
  font-size: 10.5px;
  color: #94a3b8;
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.epx-dmn-sim__feel-input {
  width: 100%;
  background: #0b1220;
  border: 1px solid #334155;
  color: #e2e8f0;
  padding: 6px 8px;
  font-size: 11.5px;
  border-radius: 3px;
  font-family: "SF Mono", Menlo, monospace;
  resize: vertical;
  min-height: 32px;
}
.epx-dmn-sim__feel-input:focus {
  outline: none;
  border-color: var(--epx-dmn-sim-accent);
  background: #020617;
}

/* ── Result cards: assertions summary + badges + diff ────────────── */

.epx-dmn-sim__assert-summary {
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 3px;
  text-align: center;
  letter-spacing: 0.2px;
}
.epx-dmn-sim__assert-summary--pass {
  background: rgba(16, 185, 129, 0.15);
  color: #6ee7b7;
  border: 1px solid rgba(16, 185, 129, 0.3);
}
.epx-dmn-sim__assert-summary--fail {
  background: rgba(239, 68, 68, 0.15);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.epx-dmn-sim__dec-title-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 6px;
  margin-bottom: 4px;
}

.epx-dmn-sim__assert-badge {
  font-size: 9.5px;
  font-weight: 600;
  padding: 1px 6px;
  border-radius: 8px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  flex-shrink: 0;
}
.epx-dmn-sim__assert-badge--pass {
  background: rgba(16, 185, 129, 0.18);
  color: #6ee7b7;
}
.epx-dmn-sim__assert-badge--fail {
  background: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
}

.epx-dmn-sim__dec--pass { border-left-color: #10b981; }
.epx-dmn-sim__dec--fail { border-left-color: #ef4444; }

.epx-dmn-sim__dec-diff {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.epx-dmn-sim__dec-diff-line {
  font-size: 11px;
  display: flex;
  align-items: baseline;
  gap: 5px;
  flex-wrap: wrap;
}

.epx-dmn-sim__dec-diff-tag {
  font-size: 9.5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fca5a5;
  letter-spacing: 0.3px;
  flex-shrink: 0;
}
.epx-dmn-sim__dec-diff-tag--err { color: #fbbf24; }

.epx-dmn-sim__dec-diff code {
  background: #020617;
  color: #f1f5f9;
  padding: 1px 6px;
  border-radius: 3px;
  font-family: "SF Mono", Menlo, monospace;
  font-size: 11px;
  word-break: break-word;
}
`, "",{"version":3,"sources":["webpack://./../epx-dmn/src/simulator/simulationStyles.css"],"names":[],"mappings":"AAAA;+DAC+D;;AAE/D;EACE;2DACyD;EACzD,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,mCAAmC;EACnC,wCAAwC;;EAExC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,8EAA8E;EAC9E,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;EAClC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6DAA6D;AAC/D;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,aAAa;EACb,oCAAoC;EACpC,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,sEAAsE;;AAEtE;EACE,OAAO;EACP,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,4CAA4C;AAC9C;AACA,8BAA8B,oCAAoC,EAAE;AACpE;EACE,qDAAqD;EACrD,mDAAmD;AACrD;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA,8BAA8B,qCAAqC,EAAE,4CAA4C,EAAE,qDAAqD,EAAE;AAC1K,8BAA8B,cAAc,EAAE,qBAAqB,EAAE,mCAAmC,EAAE;;AAE1G;;EAEE,cAAc;EACd,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,8CAA8C;AAChD;AACA,0BAA0B,mBAAmB,EAAE,qBAAqB,EAAE;AACtE;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,oGAAoG;EACpG,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,4CAA4C;EAC5C,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,iCAAiC,cAAc,EAAE,kCAAkC,EAAE;AACrF;EACE,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA,gCAAgC,qCAAqC,EAAE;;AAEvE,sEAAsE;;AAEtE;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,sEAAsE;;AAEtE;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,0DAA0D;EAC1D,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;AACA,kCAAkC,cAAc,EAAE,gBAAgB,EAAE;;AAEpE;EACE,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA,kCAAkC,cAAc,EAAE;;AAElD;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;AACA,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;;AAElD;EACE,OAAO;EACP,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;AACA,oCAAoC,cAAc,EAAE,qBAAqB,EAAE;;AAE3E;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;AACA,2BAA2B,0BAA0B,EAAE;;AAEvD;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,wCAAwC;EACxC,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,uEAAuE;;AAEvE;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA,oCAAoC,cAAc,EAAE;;AAEpD;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,uEAAuE;;AAEvE;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,0BAA0B,0BAA0B,EAAE;AACtD,0BAA0B,0BAA0B,EAAE;;AAEtD;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;AACA,kCAAkC,cAAc,EAAE;;AAElD;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,sBAAsB;AACxB","sourcesContent":["/* SimulationPanel — 3-column layout (templates / active / results).\n   Designed to live inside the dark DMN overlay (dark theme). */\n\n.epx-dmn-sim {\n  /* Accent tokens — host themes (e.g. sfd-v2 Themis) override these\n     to repaint the simulator without touching internals. */\n  --epx-dmn-sim-accent:       #0ea5e9;\n  --epx-dmn-sim-accent-hover: #0891b2;\n  --epx-dmn-sim-accent-soft:  #7dd3fc;\n  --epx-dmn-sim-accent-deep:  #0e7490;\n  --epx-dmn-sim-accent-rgb:   14, 165, 233;\n\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #0b1220;\n  color: #e2e8f0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  font-size: 12.5px;\n  position: relative;\n}\n\n.epx-dmn-sim__close {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  z-index: 5;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  border: 1px solid #334155;\n  background: rgba(15, 23, 42, 0.85);\n  color: #94a3b8;\n  font-size: 13px;\n  line-height: 1;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.12s, border-color 0.12s, background 0.12s;\n}\n.epx-dmn-sim__close:hover {\n  color: #fca5a5;\n  border-color: #ef4444;\n  background: rgba(15, 23, 42, 0.95);\n}\n\n.epx-dmn-sim__root {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 240px 1fr 2fr;\n  min-height: 0;\n  gap: 1px;\n  background: #1e293b;\n}\n\n.epx-dmn-sim__col {\n  background: #0f172a;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.epx-dmn-sim__col-head {\n  flex: 0 0 auto;\n  padding: 8px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #94a3b8;\n  background: #111827;\n  border-bottom: 1px solid #1e293b;\n}\n\n.epx-dmn-sim__muted {\n  padding: 12px;\n  color: #64748b;\n  font-size: 12px;\n}\n\n/* ── Templates column ───────────────────────────────────────────── */\n\n.epx-dmn-sim__templates {\n  flex: 1;\n  overflow-y: auto;\n  padding: 6px;\n}\n\n.epx-dmn-sim__tpl-row {\n  display: grid;\n  grid-template-columns: 18px 1fr 30px 26px;\n  gap: 6px;\n  align-items: center;\n  padding: 8px 10px;\n  margin-bottom: 2px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background 0.1s, box-shadow 0.1s;\n}\n.epx-dmn-sim__tpl-row:hover { background: rgba(148, 163, 184, 0.1); }\n.epx-dmn-sim__tpl-row.is-active {\n  background: rgba(var(--epx-dmn-sim-accent-rgb), 0.18);\n  box-shadow: inset 3px 0 0 var(--epx-dmn-sim-accent);\n}\n.epx-dmn-sim__tpl-row.is-active .epx-dmn-sim__tpl-name {\n  color: #f1f5f9;\n  font-weight: 600;\n}\n\n.epx-dmn-sim__tpl-name {\n  color: #e2e8f0;\n  font-size: 12.5px;\n  padding: 3px 2px;\n  min-width: 0;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n}\n\n.epx-dmn-sim__tpl-name--editing {\n  background: #0b1220;\n  border: 1px solid var(--epx-dmn-sim-accent);\n  border-radius: 3px;\n  outline: none;\n  color: #e2e8f0;\n  font-size: 12.5px;\n  padding: 3px 5px;\n  font-family: inherit;\n}\n\n.epx-dmn-sim__tpl-run,\n.epx-dmn-sim__tpl-del {\n  background: transparent;\n  border: 1px solid #334155;\n  color: #94a3b8;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 4px 6px;\n  line-height: 1;\n}\n.epx-dmn-sim__tpl-run:hover { color: var(--epx-dmn-sim-accent-soft); border-color: var(--epx-dmn-sim-accent-soft); background: rgba(var(--epx-dmn-sim-accent-rgb), 0.08); }\n.epx-dmn-sim__tpl-del:hover { color: #ef4444; border-color: #ef4444; background: rgba(239, 68, 68, 0.08); }\n\n.epx-dmn-sim__tpl-toolbar,\n.epx-dmn-sim__runbar {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 6px;\n  padding: 6px 8px;\n  border-top: 1px solid #1e293b;\n}\n\n.epx-dmn-sim__runbar {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 6px;\n  background: #0b1220;\n}\n\n.epx-dmn-sim__live {\n  font-size: 11px;\n  color: #94a3b8;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  user-select: none;\n  cursor: pointer;\n}\n\n.epx-dmn-sim__btn {\n  background: #1e293b;\n  border: 1px solid #334155;\n  color: #e2e8f0;\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: background 0.1s, border-color 0.1s;\n}\n.epx-dmn-sim__btn:hover { background: #334155; border-color: #475569; }\n.epx-dmn-sim__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.epx-dmn-sim__btn--primary {\n  background: linear-gradient(135deg, var(--epx-dmn-sim-accent-deep), var(--epx-dmn-sim-accent-hover));\n  border-color: var(--epx-dmn-sim-accent-soft);\n  color: #f0fdfa;\n  font-weight: 500;\n}\n.epx-dmn-sim__btn--primary:hover {\n  background: var(--epx-dmn-sim-accent-deep);\n  border-color: var(--epx-dmn-sim-accent-soft);\n  filter: brightness(0.92);\n}\n.epx-dmn-sim__btn--ghost {\n  background: transparent;\n  border-color: #334155;\n  color: #94a3b8;\n  font-size: 11px;\n  padding: 4px 8px;\n}\n.epx-dmn-sim__btn--ghost:hover { color: #e2e8f0; background: rgba(148,163,184,0.08); }\n.epx-dmn-sim__btn--link {\n  background: transparent;\n  border: none;\n  color: var(--epx-dmn-sim-accent);\n  padding: 2px 0;\n  font-size: 11.5px;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n.epx-dmn-sim__btn--link:hover { color: var(--epx-dmn-sim-accent-soft); }\n\n/* ── Active scenario column ─────────────────────────────────────── */\n\n.epx-dmn-sim__active-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 12px;\n}\n\n.epx-dmn-sim__input-row {\n  margin-bottom: 12px;\n}\n\n.epx-dmn-sim__input-label {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  font-size: 11px;\n  color: #cbd5e1;\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.epx-dmn-sim__input-type {\n  color: #64748b;\n  font-size: 10px;\n  font-family: monospace;\n  background: #1e293b;\n  padding: 1px 5px;\n  border-radius: 3px;\n}\n\n.epx-dmn-sim__input {\n  width: 100%;\n  background: #0b1220;\n  border: 1px solid #334155;\n  color: #e2e8f0;\n  padding: 5px 8px;\n  font-size: 12px;\n  border-radius: 3px;\n  font-family: \"SF Mono\", Menlo, monospace;\n}\n.epx-dmn-sim__input:focus {\n  outline: none;\n  border-color: var(--epx-dmn-sim-accent);\n  background: #020617;\n}\n\n/* ── Results column ─────────────────────────────────────────────── */\n\n.epx-dmn-sim__results-strip {\n  flex: 1;\n  overflow-x: auto;\n  overflow-y: hidden;\n  padding: 10px;\n  display: flex;\n  gap: 10px;\n  align-items: stretch;\n}\n\n.epx-dmn-sim__focus-pill {\n  flex: 0 0 auto;\n  align-self: center;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: rgba(var(--epx-dmn-sim-accent-rgb), 0.15);\n  border: 1px solid rgba(var(--epx-dmn-sim-accent-rgb), 0.4);\n  color: var(--epx-dmn-sim-accent-soft);\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  white-space: nowrap;\n}\n.epx-dmn-sim__focus-pill strong { color: #e2e8f0; font-weight: 600; }\n\n.epx-dmn-sim__focus-clear {\n  background: transparent;\n  border: none;\n  color: var(--epx-dmn-sim-accent-soft);\n  font-size: 13px;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0 2px;\n}\n.epx-dmn-sim__focus-clear:hover { color: #fca5a5; }\n\n.epx-dmn-sim__result-card {\n  flex: 0 0 260px;\n  background: #111827;\n  border: 1px solid #1e293b;\n  border-radius: 5px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n  max-height: 100%;\n}\n\n.epx-dmn-sim__result-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid #1e293b;\n}\n\n.epx-dmn-sim__result-icon {\n  font-weight: 700;\n  font-size: 14px;\n  width: 18px;\n  text-align: center;\n}\n.epx-dmn-sim__result-icon--ok   { color: #10b981; }\n.epx-dmn-sim__result-icon--fail { color: #ef4444; }\n.epx-dmn-sim__result-icon--idle { color: #64748b; }\n\n.epx-dmn-sim__result-name {\n  flex: 1;\n  font-weight: 500;\n  font-size: 12.5px;\n  color: #e2e8f0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.epx-dmn-sim__result-expand {\n  background: transparent;\n  border: 1px solid #334155;\n  color: #94a3b8;\n  border-radius: 3px;\n  padding: 2px 8px;\n  font-size: 10.5px;\n  cursor: pointer;\n}\n.epx-dmn-sim__result-expand:hover { color: #e2e8f0; border-color: #475569; }\n\n.epx-dmn-sim__result-error {\n  color: #fca5a5;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  padding: 6px 8px;\n  border-radius: 3px;\n  font-size: 11.5px;\n  white-space: pre-wrap;\n  font-family: \"SF Mono\", Menlo, monospace;\n}\n\n.epx-dmn-sim__dec {\n  padding: 6px 8px;\n  background: #0b1220;\n  border-radius: 3px;\n  border-left: 3px solid #10b981;\n}\n.epx-dmn-sim__dec--error { border-left-color: #ef4444; }\n\n.epx-dmn-sim__dec-title {\n  font-size: 11px;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  margin-bottom: 4px;\n}\n\n.epx-dmn-sim__dec-value {\n  margin: 0;\n  font-family: \"SF Mono\", Menlo, monospace;\n  font-size: 12px;\n  color: #f1f5f9;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.epx-dmn-sim__dec-meta {\n  font-size: 10.5px;\n  color: #64748b;\n  margin-top: 4px;\n}\n\n.epx-dmn-sim__crumb {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.epx-dmn-sim__crumb-text {\n  color: #fbbf24;\n  font-size: 11.5px;\n  font-weight: 500;\n}\n\n.epx-dmn-sim__crumb-msg {\n  color: #fca5a5;\n  font-family: \"SF Mono\", Menlo, monospace;\n  font-size: 11px;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.epx-dmn-sim__trace {\n  margin-top: 4px;\n  font-size: 10.5px;\n}\n.epx-dmn-sim__trace summary {\n  cursor: pointer;\n  color: #94a3b8;\n  padding: 2px 0;\n}\n.epx-dmn-sim__trace pre {\n  margin: 4px 0 0;\n  padding: 6px 8px;\n  background: #020617;\n  border-radius: 3px;\n  font-family: \"SF Mono\", Menlo, monospace;\n  font-size: 10.5px;\n  color: #cbd5e1;\n  white-space: pre-wrap;\n  word-break: break-all;\n  max-height: 140px;\n  overflow-y: auto;\n}\n\n/* ── Active column: subheaders + expected section ────────────────── */\n\n.epx-dmn-sim__subhead {\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin: 0 0 8px;\n  padding-bottom: 4px;\n  border-bottom: 1px solid #1e293b;\n}\n\n.epx-dmn-sim__expected {\n  margin-top: 18px;\n  border-top: 1px dashed #1e293b;\n  padding-top: 10px;\n}\n\n.epx-dmn-sim__expected-head {\n  width: 100%;\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n  background: transparent;\n  border: none;\n  color: #cbd5e1;\n  font-size: 11.5px;\n  font-weight: 600;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  padding: 4px 0;\n  cursor: pointer;\n  text-align: left;\n}\n.epx-dmn-sim__expected-head:hover { color: #e2e8f0; }\n\n.epx-dmn-sim__expected-caret {\n  font-size: 10px;\n  color: #64748b;\n  width: 12px;\n  display: inline-block;\n}\n\n.epx-dmn-sim__expected-hint {\n  text-transform: none;\n  letter-spacing: 0;\n  font-weight: 400;\n  color: #64748b;\n  font-size: 10.5px;\n}\n\n.epx-dmn-sim__expected-body {\n  margin-top: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.epx-dmn-sim__expected-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.epx-dmn-sim__expected-label {\n  font-size: 11.5px;\n  color: #cbd5e1;\n  font-weight: 500;\n}\n\n.epx-dmn-sim__expected-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-left: 8px;\n  border-left: 2px solid #1e293b;\n}\n\n.epx-dmn-sim__expected-sub {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.epx-dmn-sim__expected-sublabel {\n  font-size: 10.5px;\n  color: #94a3b8;\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n.epx-dmn-sim__feel-input {\n  width: 100%;\n  background: #0b1220;\n  border: 1px solid #334155;\n  color: #e2e8f0;\n  padding: 6px 8px;\n  font-size: 11.5px;\n  border-radius: 3px;\n  font-family: \"SF Mono\", Menlo, monospace;\n  resize: vertical;\n  min-height: 32px;\n}\n.epx-dmn-sim__feel-input:focus {\n  outline: none;\n  border-color: var(--epx-dmn-sim-accent);\n  background: #020617;\n}\n\n/* ── Result cards: assertions summary + badges + diff ────────────── */\n\n.epx-dmn-sim__assert-summary {\n  font-size: 11px;\n  font-weight: 500;\n  padding: 4px 8px;\n  border-radius: 3px;\n  text-align: center;\n  letter-spacing: 0.2px;\n}\n.epx-dmn-sim__assert-summary--pass {\n  background: rgba(16, 185, 129, 0.15);\n  color: #6ee7b7;\n  border: 1px solid rgba(16, 185, 129, 0.3);\n}\n.epx-dmn-sim__assert-summary--fail {\n  background: rgba(239, 68, 68, 0.15);\n  color: #fca5a5;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.epx-dmn-sim__dec-title-row {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.epx-dmn-sim__assert-badge {\n  font-size: 9.5px;\n  font-weight: 600;\n  padding: 1px 6px;\n  border-radius: 8px;\n  letter-spacing: 0.3px;\n  text-transform: uppercase;\n  flex-shrink: 0;\n}\n.epx-dmn-sim__assert-badge--pass {\n  background: rgba(16, 185, 129, 0.18);\n  color: #6ee7b7;\n}\n.epx-dmn-sim__assert-badge--fail {\n  background: rgba(239, 68, 68, 0.18);\n  color: #fca5a5;\n}\n\n.epx-dmn-sim__dec--pass { border-left-color: #10b981; }\n.epx-dmn-sim__dec--fail { border-left-color: #ef4444; }\n\n.epx-dmn-sim__dec-diff {\n  margin-top: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.epx-dmn-sim__dec-diff-line {\n  font-size: 11px;\n  display: flex;\n  align-items: baseline;\n  gap: 5px;\n  flex-wrap: wrap;\n}\n\n.epx-dmn-sim__dec-diff-tag {\n  font-size: 9.5px;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #fca5a5;\n  letter-spacing: 0.3px;\n  flex-shrink: 0;\n}\n.epx-dmn-sim__dec-diff-tag--err { color: #fbbf24; }\n\n.epx-dmn-sim__dec-diff code {\n  background: #020617;\n  color: #f1f5f9;\n  padding: 1px 6px;\n  border-radius: 3px;\n  font-family: \"SF Mono\", Menlo, monospace;\n  font-size: 11px;\n  word-break: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
